/**
 * AudiencePicker — Nursing Student / NP Student view toggle.
 *
 * Jul 2026 pivot: the platform serves exactly two views. This picker
 * flips the shared learner view (lib/view.js) instead of the legacy
 * community/student track system.
 *
 * Variants:
 *   - "cards" : 2 large white cards
 *   - "chip"  : compact pill group
 */
import { VIEWS, useView } from "../lib/view";

export default function AudiencePicker({ variant = "cards", onPicked }) {
  const [view, setView] = useView();

  function choose(id) {
    setView(id);
    if (onPicked) onPicked(id);
  }

  if (variant === "chip") {
    return (
      <div
        className="inline-flex items-center gap-1 p-1 rounded-full"
        style={{ background: "#eaedf0", border: "1px solid #d5d9dd" }}
        data-testid="audience-chip"
      >
        {VIEWS.map((v) => {
          const active = view === v.id;
          return (
            <button
              key={v.id}
              type="button"
              onClick={() => choose(v.id)}
              data-testid={`aud-chip-${v.id}`}
              className="px-3 py-1 rounded-full text-[12px] font-semibold whitespace-nowrap transition-all"
              style={active
                ? { background: v.accent, color: "#ffffff" }
                : { color: "#5d5748" }}
            >
              {v.short}
            </button>
          );
        })}
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-testid="audience-cards">
      {VIEWS.map((v) => {
        const active = view === v.id;
        return (
          <button
            key={v.id}
            type="button"
            onClick={() => choose(v.id)}
            data-testid={`aud-card-${v.id}`}
            className="glass-card text-left group"
            style={active ? {
              borderColor: v.accent,
              boxShadow: `0 0 0 1px ${v.accent}44, 0 16px 40px ${v.accent}22`,
            } : {}}
          >
            <p
              className="text-[12px] font-mono uppercase tracking-[0.22em] mb-2 font-semibold"
              style={{ color: v.accent }}
            >
              {v.label}
            </p>
            <h3 className="font-heading text-2xl tracking-tight font-bold" style={{ color: "#2b261c" }}>
              {v.label}
            </h3>
            <p
              className="mt-4 text-[12px] font-mono uppercase tracking-widest font-semibold"
              style={{ color: v.accent }}
            >
              {active ? "✓ this is you" : "Pick this view →"}
            </p>
          </button>
        );
      })}
    </div>
  );
}
